import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { Identifier } from '../types/identifier';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import TablePaginationActions from './TablePaginationActions';
import useConfigStyles from './useConfigStyles';
import { Group } from 'types/group';

type DropDownSelectListProps = {
  editable?: boolean;
  dataType?: string;
  availableData: Identifier[];
  group: Group;
  setData: (data: Identifier[]) => void;
};

export default function DropDownSelectList({ editable, dataType, availableData, group, setData }: DropDownSelectListProps): JSX.Element {
  const classes = useConfigStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [inputKey, setInputKey] = useState('');
  const [selectedTable, setSelectedTable] = useState(group.Rules);
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    var newRules = group.Rules;
    setSelectedTable(newRules)
  }, [group, group.Rules])

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onChangeSelect = (event: React.SyntheticEvent<Element, Event>, value: string | null) => {
    if (value != undefined && value != '') {
      const newSelectedTable = [...selectedTable];
      const counter = group.Rules.length + 1;
      setInputKey(Date.now().toString());
      newSelectedTable.push({
        Name: value,
        Id: counter.toString(),
      });
      setSelectedTable(newSelectedTable);
      setData(newSelectedTable);
    }

    return null;
  };

  const handleDelete = (name: string) => {
    const currentIndex = selectedTable.findIndex((x) => x.Name == name);
    const newSelectedTable = [...selectedTable];
    newSelectedTable.splice(currentIndex, 1);

    setSelectedTable(newSelectedTable);
    setData(newSelectedTable);
  };

  const deleteSection = (row: string) => {
    return (
      <TableCell>
        {editable && (
          <IconButton
            onClick={() => {
              handleDelete(row);
            }}
            className={classes.error}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </TableCell>
    );
  };

  return (
    <Grid container spacing={2} alignItems='center' justifyContent='space-evenly' className={classes.root}>
      <Grid item hidden={!editable} xs={10}>
        <Autocomplete disablePortal key={inputKey} size='small' onChange={onChangeSelect} options={availableData.map((x) => x.Name).filter((rules) => !selectedTable.find((w) => w.Name == rules))} renderInput={(params) => <TextField {...params} label='Add new rule' />} clearOnBlur={true} />
      </Grid>
      <Grid item xs={10}>
        <FormLabel>Selected {dataType}</FormLabel>
        <TableContainer component={Paper}>
          <Table className='table' padding='none'>
            <TableHead>
              <TableRow>
                <TableCell>Rule Name</TableCell>
                <TableCell>{editable ? 'Action' : ''}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <TableRow key={index}>
                  <TableCell component='th' scope='row'>
                    {row.Name}
                  </TableCell>
                  {deleteSection(row.Name)}
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5]}
                  colSpan={3}
                  count={selectedTable.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page',
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

DropDownSelectList.defaultProps = {
  editable: false,
  dataType: 'Items',
};
